import { gql } from 'graphql-request';

export const getSearchResultQuery = gql`
  query getSearchResult($query: String!, $session_id: String) {
    getSearchResult(query: $query, session_id: $session_id) {
      context_ids
      search_id
      message
      timestamp
    }
  }
`;

export const postSearchResultFeedbackQuery = gql`
  query postSearchResultFeedback($search_id: String!, $is_correct: Boolean, $comment: String, $session_id: String!) {
    postSearchResultFeedback(
      search_id: $search_id
      is_correct: $is_correct
      comment: $comment
      session_id: $session_id
    ) {
      success
    }
  }
`;
